//rafl = Reload after favourite login; upa = Url private area; al = Ads favourites
var rafl = false;
var upa = '/internalArea/home';
var al;
	
	/*******************************************************
	 *  Clase del menu de login 
	 *******************************************************/
function setPreventAndPropagation(e) {
	e.preventDefault();
	e.stopPropagation();
}

	function Login(element){
			var self = this;
			this.$el =  $(element);		
	}

	var loginModalContent;	
	var loginEventInit = '';

	Login.prototype.init = function(){
		var self = this;
		
		this.$el.find('.icon.login').on('click',function(e){
			setPreventAndPropagation(e);
			googleInit();
			openDefaultLoginModal(e);		
		});

		$('.menu__layer').on('click', function(){			
			if($('.menu').is(':visible')){
				$('.menu .menu__arrow .ui-link-0').trigger('click');
			}
			$('.menu__layer').removeClass('is-active');
		})
		
		this.$el.on('click',function(e){
			if(self.$el.hasClass('is-active')){
				if($(e.target).closest('.menu').length===0){
					self.$el.removeClass('is-active');
					$('.menu__layer').removeClass('is-active');
					loginEventInit = '';
				}
			}
		});

	}

$(document).ready(function(){
	
	$('.currency-selector').on('click', function(){
		try {
			analytics.submitEventAction(awp, analyticsObjects.actions.gotoAction, analyticsObjects.labelElements.currency+'-'+$(this).attr('data-val').toLowerCase());
		} catch(e) {;}
		jsUtils.setCookie("_currency", $(this).attr('data-val'), 1000);
		location.reload(true);
	});

	if(!userLogged){
		var login = new Login('header');
		login.init();
	}
	
	$('.menu__layer').on('click', function(){
		if($(this).hasClass('is-active')){
			$(this).removeClass('is-active');
		}
	});

	$('.js-dropdown').each(function(index,element){
		var drop = new Dropdown(element,{setItemActive:""});
		drop.arrayElement = index;
		Dropdown.prototype.dropdownArray.push(drop.init());
	});

	$(document).click(function(){
		$(Dropdown.prototype.dropdownArray).each(function(index,element){
			element.closeDropdown();
		});
	});

	$('#openHeaderMenuMobile').click(function (e) {
		openHeaderMenuMobile(e);
	});

	$('nav.migas').on('click', 'li', function (e) {
		breadcrumbGoto(e, this);
	});

	$('.capitals-list > li').on('click', '.linkFilter', function (e) {
		capitalsGoto(e, this);
	});

	$('.menu').on('click', '#recoverPassword', function (e) {
		recoverPasswordGoto(e, this);
	});

	$('header').on('click', '.div-logo', function (e) {
		logoGoto(e, this);
	});
	
	loginModalContent = $(".menu").html();
	
	checkTestAB();
	
});

/*******************************************************
 *  Clase del componente Dropdown 
 *******************************************************/

function Dropdown(param,options){
	this.el = param;
	this.value = "";
	this.$el =  $(this.el);
	this.options = new Object();
	var self = this;
	if(typeof options !== 'undefined'){
		$.each(options,function(key,item){
			self.options[key] = item;
		});
	}
}

Dropdown.prototype.checkOptions = function(){
	var self = this;
	if(typeof self.options !== 'undefined'){
		$.each(self.options,function(key,item){
			(typeof self[key] !== 'undefined')? (self[key])(self.options[key]):'';
		});
	}
}

Dropdown.prototype.dropdownArray = new Array();

Dropdown.prototype.setItemActive = function(){
	var self = this;

	this.$el.on('select:dropdown:option',function(e,params){
		self.$el.find('.dropdown__list__item').removeClass('item-active');
		params.element.addClass('item-active');
		self.$el.find('input[type="hidden"]').val(params.data);
	})

}

Dropdown.prototype.setCustomScroll = function(){
	var self = this;
	this.$el.on('dropdown:open',function(){
		self.nice =	self.$el.find('.js-nice').niceScroll({
			zindex:'999999999',
			bouncescroll: 'false',
			autohidemode: true,  
			cursorborderradius: '0px', 
			cursorborder:'0px',
			cursorwidth: '6px',       
			cursorcolor: '#4d75b7',
			horizrailenabled:false,
			cursorfixedheight: '15px',
			railoffset:{
			"top":10,"left":0},
			railpadding:{ 
				top: 0,
				right: 5,
				left: 0, 
				bottom: 0 
			}, 
		});
	}).on('dropdown:collapse',function(){
		self.nice.remove();
	});

}

Dropdown.prototype.getValue = function(){
	return this.value;
}

Dropdown.prototype.setDropdown = function(param){
	var el =this.$el; 
	this.value = param;
	el.data('val',this.getValue());
	el.find('.dropdown__btn-select span.text').text(this.getValue());
	console.log('set dropdown');
}

Dropdown.prototype.toggleDropdown = function(){
	var el =this.$el; 
	if(el.hasClass('is-active')){
		el.removeClass('is-active');
		el.trigger('dropdown:collapse')
	}//No esta activo activamos el elemento
	else{
		if (el.find('.currency-selector').length>0) {
			try {
				analytics.submitEventAction(awp, analyticsObjects.actions.open, analyticsObjects.labelElements.currency);
			} catch(e) {;}
		}
		el.addClass('is-active');
		el.trigger('dropdown:open');
	}	
}

Dropdown.prototype.closeDropdown = function(){
	var el =this.$el; 
	if(el.hasClass('is-active')){
		el.removeClass('is-active').trigger('dropdown:collapse')
	}
}

Dropdown.prototype.closeOthersDropdowns = function(){
	var self = this;
	$(Dropdown.prototype.dropdownArray).each(function(index,element){
		if(element.arrayElement !== self.arrayElement){
			element.closeDropdown();
		}	

	});
}

Dropdown.prototype.init = function(){
	var self = this;
	this.checkOptions();
	//Apertura cierre del dropdown	
	$(self.el).on('click',function(e){
		e.stopPropagation();
		self.toggleDropdown();
		self.closeOthersDropdowns();
	});
	//seleccion del dropdown 
	self.$el.find('.dropdown__list').delegate('.dropdown__list__item','click',function(e){
		setPreventAndPropagation(e);
		self.closeDropdown();	
		var liElement = $(e.currentTarget);
		self.setDropdown(liElement.text());
		self.$el.trigger('select:dropdown:option',{'data':liElement.data('val'),'id':liElement.data('id'),'element':liElement})
	});
	
	return (this);
};

function openHeaderMenuMobile(e) {

	try {
		analytics.submitEventAction(awp, analyticsObjects.actions.open, analyticsObjects.labelElements.headerMenuMobile);
	} catch(e) {;}
	var itemList = $('ul.items-list');
	if (itemList.find('.li-logo').length==0) {
		itemList.prepend($(document.createElement("li")).addClass('li-logo').html($('.div-logo').html() + '<i class="icon-r-cross" id="closeHeaderMenuMobile"></i>'));
	}
	$('body').addClass("blocking");
	$('header').addClass('active');
	itemList.addClass('active');
	$('.menu__layer').addClass('is-active openHeaderMenuMobile');

	setPreventAndPropagation(e);

	$('.menu__layer.is-active').on("click", function(e) {
		setPreventAndPropagation(e); 
		closeHeaderMenuMobile();
	});
	$('#closeHeaderMenuMobile').on('click', function (e) {
		closeHeaderMenuMobile();
	});
}

function closeHeaderMenuMobile() {
	$('header').removeClass('active');
	$('ul.items-list').removeClass('active');  
	$('body').removeClass("blocking");
	$('.menu__layer').removeClass('is-active openHeaderMenuMobile');
	$('#closeHeaderMenuMobile').off('click');
	$('.menu__layer.is-active').off("click");
}

function breadcrumbGoto(e, obj) {
	setPreventAndPropagation(e);

	try {
		var elementNumber = eval($(obj).parent().children().index(obj)+1);
		var totalElements = $(obj).parent().find('li').length;

		analytics.submitEventAction(awp, analyticsObjects.actions.gotoAction, analyticsObjects.labelElements.breadcrumb+'-'+elementNumber+'-'+totalElements);
	} catch(e) {;}

	window.location.href=$(obj).find('a').attr('href');
}

function capitalsGoto(e, obj) {
	setPreventAndPropagation(e);

	try {
		analytics.submitEventAction(awp, analyticsObjects.actions.gotoAction, analyticsObjects.labelElements.capitals);
	} catch(e) {;}

	window.location.href=obj.href;
}

function logoGoto(e, obj) {
	setPreventAndPropagation(e);

	try {
		analytics.submitEventAction(awp, analyticsObjects.actions.gotoAction, analyticsObjects.labelElements.logoToHome);
	} catch(e) {;}

	window.location.href=$(obj).find('a').attr('href');
}

function openDefaultLoginModal(e) {
	openLoginModal(e, function () {
		document.location.href=upa;
	});			
}

var callbackFunctionLoginDone;

function openLoginModal(e, callback) {

	try {
		closeHeaderMenuMobile();
	} catch(e) {;}
	
	try {
		analytics.submitEventLogin(analyticsObjects.actions.open, awp, loginEventInit);
	} catch(e) {;}
	
	$('.menu__layer').addClass('is-active');
	$(this).toggleClass('active');
	$('body').addClass("blocking");
	if ($('.menu').css('position')!='fixed') {
		$(document).scrollTop(0);
	}
	$('.menu ').show();
	
	$('header .sprite.login, header .icon.login').addClass('active');
	
	loginEvents(e);
	callbackFunctionLoginDone = callback;
}

function loginEvents(e) {
	$('form.login').off('click', '.ui-button-1').on('click', '.ui-button-1', function(e){
		execLogin(e, this);
	});	
	
	$('.menu').off('click', '#signUp').on('click', '#signUp', function(e){
		signUp(e, this);
	});	
	
	closeModalEvents()
}

function closeModalEvents() {
	$('.menu .menu__arrow').off('click', '.ui-link-0').on('click', '.ui-link-0', function(e){
		e.preventDefault();
		$('.menu').hide();
		$('.menu__layer').removeClass('is-active');
		$('body').removeClass("blocking");
		$('header .sprite.login, header .icon.login').removeClass('active');
		loginEventInit = '';
		
		returnToLogin(e);
	});
}

function execLogin(e, obj) {
	setPreventAndPropagation(e);
	
	form = $(obj).parents("form");
	var email = form.find('#loginMail').val();
	var password = form.find('#loginPassword').val();
	var ret=false;
	
	form.find('input').each(function(index, elem){
		$(obj).removeClass('has-error');
	});
	form.find('#loginFail').hide();
	
	if(!email || !jsUtils.validateMail(email)){
		ret=true;
		form.find('#loginMail').addClass('has-error');
	} 
	if(!password){
		ret = true;
		form.find('#loginPassword').addClass('has-error');
	}
	
	if(ret)
		return false;
		
	var params = {
		"email": email,
		"pwd": password,
		"fromModal": true,
	};
		
	loginAjaxConnection(params, form);
}

function recoverPasswordGoto(e, obj) {
	setPreventAndPropagation(e);

	try {
		analytics.submitEventAction(awp, analyticsObjects.actions.gotoAction, analyticsObjects.labelElements.recoverPassword);
	} catch(e) {;}

	var url = "/www/resem/new_design/common/recoverPasswordModal.jsp";
	$.ajax({
		url: url,
		type: 'post',
		success: function (response) {
			$(".menu").html(response);
			$(".menu .ui-text-grey-1 a:not(ui-text-blue-1)").addClass("ui-text-blue-1");
			recoverPasswordEvents();
		}
	});
}

function recoverPasswordEvents() {
	var forgottenMailForm = $('#forgottenMailForm');
	forgottenMailForm.off('click', '#idLogin').on('click', '#idLogin', function (e) {
		returnToLogin(e);
	}).off('click', '#btnContinue').on('click', '#btnContinue', function (e) {
		recoverPasswordSend(e);
	});
	
	$(document).on('keydown', '#forgottenMailForm', function (e) {
	    if (e.keyCode == 13) {
	        var inputs = $(this).parents("form").eq(0).find(":input");
	        if (inputs[inputs.index(this) + 1] != null) {                    
	            inputs[inputs.index(this) + 1].focus();
	        }
	        e.preventDefault();
	        return false;
	    }
	});
	
	forgottenMailForm.off('click', '#recover').on('click', '#recover', function (e) {
		recoverPasswordGoto(e, this);
	});
	
	closeModalEvents();
}

function returnToLogin(e) {
	if (loginModalContent !== undefined) {
		$(".menu").html(loginModalContent);
		loginEvents(e);
	}
}

function recoverPasswordSend(e) {
	setPreventAndPropagation(e);
	var forgottenMailReg =  $("#forgottenMailReg");
	var forgottenMailForm =  $("#forgottenMailForm");
	
	email =forgottenMailReg.val();
	if(!email || !jsUtils.validateMail(email)){
		forgottenMailReg.addClass("has-error");
		return false;
	} else {
		forgottenMailReg.removeClass("has-error");
		$.ajax({
			url: forgottenMailForm.attr('action'),
			type: 'post',
			data: forgottenMailForm.serialize(), 
			success: function (response) {
				if (response !== undefined && response.startsWith('error=')) {
					forgottenMailForm.find('#loginFail').html(response.substr(6));
					forgottenMailForm.find('#loginFail').show();
				} else {
					$(".menu").html(response);
					$(".menu .ui-text-grey-1 a:not(ui-text-blue-1)").addClass("ui-text-blue-1");
					recoverPasswordEvents();
				}
			}
		});
	}
}

function signUp(e, obj) {
	if ($(obj).data('where') !==undefined) {
		analytics.submitRegister($(obj).data('where'));
	}
	$.ajax({
		url: '/www/resem/new_design/common/signUpModal.jsp',
		type: 'post', 
		success: function (response) {
			$(".menu").html(response);
			$(".menu .ui-text-grey-1 a:not(ui-text-blue-1)").addClass("ui-text-blue-1");
			signUpEvents();
		}
	});
}

function signUpEvents() {
	
	$("#signUpForm").off('click', '.uExternal').on('click', '.uExternal', function (e) {
		setPreventAndPropagation(e);
		launching(this.id);
	}).off('click', '#btnSignUp').on('click', '#btnSignUp', function (e) {
		execSignUp(e, this);
	}).off('click', '#idLogin').on('click', '#idLogin', function (e) {
		returnToLogin(e);
	});
	
	closeModalEvents();
	
}

function getPvParams() {
	var attributes = document.body.attributes;
	var result = {};
	var attr, attrName, attrVal;
	for (var i = 0; i < attributes.length; i++) {
		attr = attributes[i];
		attrName = attr.name;
		attrVal = attr.value;
		if(typeof attrName != 'undefined' && attrName.indexOf("data-pv") == 0) {
			attrName = attrName.replace("data-", "");
			result[attrName]=attrVal;
		}
	}
	result = JSON.stringify(result);
	
	return result;
}


function findCookie (name) {
	var cookies = document.cookie;
	var cv = cookies.split(";");
	for (var i = 0; i < cv.length; i++) {
		var v = cv[i];
		while (v.charAt(0)==' ')
			v = v.substring(1,v.length);
		if (v.indexOf(name) == 0) {
			var value = decodeURIComponent (v.substring(name.length, v.length));
			if (value.charAt(0)=='=') {
				value = value.substring(1,value.length);
			}
			if ($(body).attr("data-pvId") == value) {
				return true;
			}
		}
	}
	
	return false;
}

function execSignUp(e, obj) {
	setPreventAndPropagation(e);
	
	form = $(obj).parents("#signUpForm");
	var name = form.find('#name').val();
	var email = form.find('#email').val();
	var password = form.find('#pwd').val();
	var repeatPassword = form.find('#repeatPwd').val();
	var ret=false;
	
	form.find('input').each(function(index, elem){
		$(this).removeClass('has-error');
	});
	form.find('#conditionsCheck').parent().removeClass('has-error');
	form.find('#loginFail').hide();
	
	if(!name || name.trim()==''){
		ret=true;
		form.find('#name').addClass('has-error');
	} 
	
	if(!email || !jsUtils.validateMail(email)){
		ret=true;
		form.find('#email').addClass('has-error');
	} 
	
	if(!password || password.trim()==''){
		ret = true;
		form.find('#pwd').addClass('has-error');
	}
	
	if(!repeatPassword || repeatPassword.trim()=='' || (password && password.trim()!='' && password!=repeatPassword)){
		ret = true;
		form.find('#repeatPwd').addClass('has-error');
	}
	
	if (!ret && form.find('#conditionsCheck:checked').length==0) {
		ret = true;
		form.find('#conditionsCheck').parent().addClass('has-error');
	}
	
	if (ret) {
		return false;
	} else {

		$.ajax({
			url: form.attr('action'),
			data: form.serialize(),
			type: 'post', 
			success: function (response) {
				if (response !== undefined && response.startsWith('error=')) {
					var signUpForm = $('#signUpForm');
					signUpForm.find('#loginFail').html(response.substr(6));
					signUpForm.find('#loginFail').show();
				} else {
					
					$(".menu").html(response);
					$(".menu .ui-text-grey-1 a:not(ui-text-blue-1)").addClass("ui-text-blue-1");
					signUpSuccessEvents();
					
				}
			}
		});
	}
}

function signUpSuccessEvents() {
	
	$('#signUpForm').off('click', '#idLogin').on('click', '#idLogin', function (e) {
		returnToLogin(e);
	}).off('click', '#recover').on('click', '#recover', function (e) {
		recoverPasswordGoto(e, this);
	});
	
	closeModalEvents();
}

function favouriteLogin(e, obj) {
	loginEventInit = analyticsObjects.labelElements.favourite;
	openLoginModal(e, function () {
		changesFavouriteAfterLogin(obj);
		saveFavourite(obj, 'forceLike', rafl);
	});
}

function favoriteLoginEvents() {
    $(document).on('click', '.heart-login', function(e) {
        setPreventAndPropagation(e);
        favouriteLogin(e, this);
    });
}

function favouriteForLoggedUserEvents() {
	$(document).on('click', '.heart-add-favourite', function(e) {
		setPreventAndPropagation(e);
		saveFavourite(this, 'like', false);
	});
}

function saveFavourite(obj, operation, reloadPage) {
	$.ajax({
		type : "POST",
		async : false,
		url : "/likeUnlike",
		dataType : "json",
		data : {
			'adId' : $(obj).attr('data-adId'),
			'operation' : operation
		},
		success : function(data) {
			if (reloadPage) {
				location.reload(true);
			} else {
				toggleFavourite(obj);
				analytics.submitFavourite(awp);
				$('.menu .menu__arrow .ui-link-0').trigger('click');
			}
		}
	});
}

function toggleFavourite(obj) {
	var classToggle = 'background-position-heart';
	if ($(obj).data('classActive') !== undefined) {
		classToggle = $(obj).data('classActive');
	}
	var objectToModifyStyle = $(obj);
	if ($(obj).data('childrenToActive') !== undefined) {
		objectToModifyStyle = objectToModifyStyle.find($(obj).data('childrenToActive'));
	}
	objectToModifyStyle.toggleClass(classToggle);	
}

function changesFavouriteAfterLogin(obj) {
	var heartLogin = $('.heart-login'); 
	var iconLogin = $('.icon.login');
	heartLogin.each(function () {
		$(this).addClass('heart-add-favourite');
		$(this).removeClass('heart-login');
		
		if ($(this).data('adid') !== undefined && al !== undefined && $(obj).data('adid')!=$(this).data('adid')) {
			for(var a = 0;a<al.length;a++) {
				if (al[a]==$(this).data('adid')) {
					toggleFavourite(this);
				}
			}
		}
	});
	heartLogin.off('click');

	iconLogin[0].href=upa;
	$(iconLogin.find('.ui-text-white-1')[0]).html($($('.icon.login').find('.ui-text-white-1')[0]).data('myAccount'));
	iconLogin.off('click');
	
}

function createFavouriteEvents() {
    favouriteForLoggedUserEvents();
    favoriteLoginEvents();
}

function loginAjaxConnection(params, form, url) {
		if(typeof url == 'undefined') {
			url = '/clientLoginServlet';
		}
		$.ajax({
		data: params,
		url: url,
		type: 'post',
		success: function (response) {
			// resultCode values:
			// 0 = OK, submit
			// -1 = user and password error
			// -2 = user error
			// -3 = password error
			if (typeof response.bean != "undefined"){
				if(response.bean.resultCode != 0) {
				form.find('#loginFail').text(response.bean.resultDescription);
				form.find('#loginFail').show();
				} else {
					// submit form to call clientLoginServlet and dispatch to internal area
					if(typeof analytics != "undefined") {
						analytics.setDimension('dimension1', response.bean.resultDescription);
						try {
							analytics.submitEventLogin(analyticsObjects.actions.enter, awp, loginEventInit);
						} catch(e) {;}
					}
					
					if (response.bean.idAdsLike !== undefined) {
						al = response.bean.idAdsLike.split('|');
					}
					if(typeof callbackFunctionLoginDone == 'undefined') {
						document.location.href = response.bean.forward;
					} else {
						callbackFunctionLoginDone();
					}
				}
			} else {
				return false;
			}
		},
		error:function(error){
			console.log(error);
		}
	});	
	
}

function checkTestAB() {
	try {
		var bodyTag = $('body'); 
		if (bodyTag.is('[data-pvTabI]') && bodyTag.attr('data-pvtabi')!="" && 
			bodyTag.is('[data-pvTabO]') && bodyTag.attr('data-pvtabo')!="") {
			try {
                gtag('event', 'ABTS_'+bodyTag.data('pvtabi')+"_"+bodyTag.data('pvtabo'), {'section': bodyTag.data('pvtabi'), 'sub_section': bodyTag.data('pvtabo')});
			} catch(e) {}
		}
	} catch(e) {;}
}

window.createFavouriteEvents = createFavouriteEvents;
window.setPreventAndPropagation = setPreventAndPropagation;
window.loginAjaxConnection = loginAjaxConnection;
window.getPvParams = getPvParams;
window.findCookie = findCookie;